export const CaretDown = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 12H8L16 22L24 12Z" fill="currentColor"/>
</svg>`;
